module.exports = __webpack_public_path__ + "static/assets/c5688298b8f9c52c5feabf2397cec9ae.gif";